import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.memeSignalUrl,
  prepareHeaders: (headers) => {
    headers.set('Access-Control-Allow-Origin', '*') // Allow CORS from any origin
    return headers
  },
})

export const memeSignalApi = createApi({
  baseQuery,
  reducerPath: 'memeSignalApi',
  endpoints: () => ({}),
})
